import tw, { styled } from 'twin.macro'
import { useDropzone } from 'react-dropzone'
import { FiUpload } from 'react-icons/fi'
import { Typography } from '@material-tailwind/react'
import { string, func, object, oneOfType } from 'prop-types'
import { fileToAttachment } from '@/utils/file-to-attachment'
import { useMemo } from 'react'

const Icon = tw.div`w-10 h-10 bg-blue-500 rounded-lg text-white flex items-center justify-center`

const Container = styled.div(({ isAttached }) => [
  tw`rounded-2xl
     px-6 
     py-8 
     gap-4
     flex 
     items-center
     justify-start`,

  isAttached && tw`border-2 border-blue-100 bg-blue-50`,
  !isAttached && tw`border-dashed border-2 border-gray-300`
])

export const FileInput = ({ className, text, handleChange, value, accept, validateFile, onInvalidFile }) => {
  const onDrop = ([file]) => {
    const error = validateFile(file)
    if (error) {
      onInvalidFile(error)
      return
    }

    fileToAttachment(file, (result) => {
      handleChange(result)
    })
  }

  const { getRootProps, getInputProps } = useDropzone({ onDrop, maxFiles: 1, accept })

  const isAttached = useMemo(() => {
    return Boolean(value?.filename)
  }, [value])

  return (
    <Container className={className} isAttached={isAttached} {...getRootProps()}>
      <input {...getInputProps()} />
      <Icon>
        <FiUpload className='w-5 h-5' />
      </Icon>
      <div className='flex flex-col'>
        {isAttached
          ? <>
            <Typography as='span' variant='paragraph'>{value.filename}</Typography>
          </>
          : <>
            <Typography variant='h6' className='font-medium text-black'>{text}</Typography>
            <Typography as='span' variant='paragraph' className=''>
              Arrastra o <span className='text-blue-500 font-medium'>carga el archivo</span>
            </Typography>
          </>
        }
      </div>
    </Container>
  )
}

FileInput.defaultProps = {
  text: '',
  className: '',
  handleChange: () => { },
  value: {},
  accept: undefined,
  validateFile: () => null,
  onInvalidFile: () => {}
}
FileInput.propTypes = {
  text: string,
  className: string,
  handleChange: func,
  value: object,
  accept: oneOfType([string, object]),
  validateFile: func,
  onInvalidFile: func
}
